import { DEFAULT_GRID_COLLUMNS, TPMEX_EXPORTER_PRODUCER_IMPORTER, EXPORTER_DETAILS, PRODUCER_DETAILS, IMPORTER_DETAILS } from "../../utils/surveyLiterals";
import { Grid, Typography } from "@deere/fuel-react";
import { useTranslation } from "react-i18next";

const TpsmexImportExport = ({ questions, getCollumnsByQuestion, createRadioSection, createDateSection, createInput, createTextArea }) => {
  const { t } = useTranslation();

  const groupQuesForColumns = (boxQuestions) => {
    let  questionSorted = questions.sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1)).filter((q) => boxQuestions.includes(q.code));
    let queColumnGroup = [];
    questionSorted.forEach((que)=>{
      let queGroup = que.questionsGroup;
      let groupFound;
      for(let i=0; i<queColumnGroup.length; i++){
        groupFound = queColumnGroup[i].find((q)=> q.questionsGroup === queGroup)
        if(groupFound)  break;
      }
      if(!groupFound){
        let group = questionSorted.filter((q)=>q.questionsGroup === queGroup);
        if(group.length > 0)  queColumnGroup.push(group);
      }
    });
    return queColumnGroup;
  }

  const renderExporterHeader =(header)=>{
    switch (header){
      case EXPORTER_DETAILS:
        return t('exporter_details');
      case PRODUCER_DETAILS:
        return t('producer_details');
      case IMPORTER_DETAILS:
        return t('importer_details');
      default: return null;
    }
  }

  return (
    <>
      {questions.sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1)).map((q) => {
          const collumnsByQuestion = q.questionsGroup ? getCollumnsByQuestion(questions, q.questionsGroup) : DEFAULT_GRID_COLLUMNS;
          if (!TPMEX_EXPORTER_PRODUCER_IMPORTER[0].questions.includes(q.code) && !TPMEX_EXPORTER_PRODUCER_IMPORTER[1].questions.includes(q.code)) {
            return (
              <Grid key={`gq-${q.id}`} item md={collumnsByQuestion}>
                <div style={{ padding: 10, paddingLeft: q.idQuestionDepends ? "1.5rem" : 10, paddingTop: 6, paddingBottom: 7 }}>
                  {q.type === "RADIO" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createRadioSection(q) : <></>}
                  {q.type === "DATE" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createDateSection(q) : <></>}
                </div>
              </Grid>
            );
          }
      })}
      {TPMEX_EXPORTER_PRODUCER_IMPORTER.map((box) => {
        return (
          <Grid item md={12} border="1px solid grey" p={4} m={2} bgcolor={box.questions ? 'white' : '#F1F1F1'}>
            <Typography gutterBottom variant="h4">{renderExporterHeader(box.header)}</Typography>
            {box.questions ? (
              <Grid container>
                  {groupQuesForColumns(box.questions).map((column)=>{
                    return (
                      <Grid container item md={6}>
                        {column.map((q)=>{
                          q = { ...q, text: q.text.split(" ").pop() };
                          return (
                            <Grid key={`gq-${q.id}`} item md={12}>
                              <div style={{ padding: 10, paddingLeft: q.idQuestionDepends ? "1.5rem" : 10, paddingTop: 6, paddingBottom: 7 }}>
                              {q.type === "OPEN_SMALL" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createInput(q) : <></>}
                              {q.type === 'OPEN' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createTextArea(q) : <></>}
                              </div>
                            </Grid>
                          )
                        })}
                      </Grid>
                    )
                  })}
              </Grid>
            ) : (
              <>
                <Typography gutterBottom variant="p" size="sm">{box.name}</Typography><br />
                <Typography gutterBottom variant="p" size="sm">{box.address}</Typography><br />
                <Typography gutterBottom variant="p" size="sm">{box.email} | {box.phone}</Typography>
              </>
            )}
          </Grid>
        );
      })}
    </>
  );
};

export default TpsmexImportExport;
